module.exports = __webpack_public_path__ + "static/media/light-r-1.4d4f8c86.png";